import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/dinamicos',
  alias: ['/sistema/reportesbi/dinamicos/Seleccionar'],
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['125'],
  cita: 'Areas/ReportesBI/Controllers/ReportesDinamicosController.cs:71',
} satisfies RutaProd;
